import * as api from 'app/lib/ajax';
import { apiRoutes } from 'app/globals';

export const loginUser = (username, password) => {
    if (process.env.REACT_APP_MOCK) return () => require('./mock').loginUser(username, password);

    return api.post(apiRoutes.USER_LOGIN, {
        username,
        password
    });

};

export const refreshUser = (jwt) => {
    if (process.env.REACT_APP_MOCK) return () => require('./mock').refreshUser(jwt);

    return api.post(apiRoutes.USER_REFRESH_LOGIN, {jwt}, {jwtHeader: false});
};


